fragment CoreEntityTaskStepSharedFragment on LeadTask {
    id
    title
    href
    description
    requirementText
    delayApplications {
        id
        note
        appliedTime
        delay {
            id
            name
            displayLength
        }
        user {
            id
            name
        }
    }
    dueTime
    assignee {
        id
        name
    }
    deletedTime
    completedTime
    canBeCompleted
    isCompleted
    completedByUser {
        id
        name
    }
    isDelayable
    isSkippable
    isSkipped
    isOverdue
    relatedEntity {
        id
        name
    }
}
